import { useCurrentCustomer, useCustomerOrderSubscription } from '@billx/api';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useBusinessParams } from '@/hooks';
import { getMenuLink } from '@/utilities';

import { AsyncWrapper } from '../common';

interface CustomerAuthGuardProps {
  children: React.ReactNode;
}

export const CustomerAuthGuard: React.FC<CustomerAuthGuardProps> = ({
  children,
}) => {
  const { businessId, outletId } = useBusinessParams();
  const { currentCustomer, isLoading: isCustomerLoading } =
    useCurrentCustomer(businessId);
  // Subscribe once order exists
  useCustomerOrderSubscription();

  if (!businessId) {
    return null;
  }

  if (isCustomerLoading) {
    return (
      <AsyncWrapper isLoading={true}>
        <></>
      </AsyncWrapper>
    );
  }

  // If not authenticated or authenticated for wrong business
  if (!currentCustomer) {
    return <Navigate to={`${getMenuLink({ businessId, outletId })}/login`} />;
  }

  return <>{children}</>;
};
